import { render, staticRenderFns } from "./SincronizacaoGeral.vue?vue&type=template&id=2e465867&"
import script from "./SincronizacaoGeral.vue?vue&type=script&lang=js&"
export * from "./SincronizacaoGeral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports